<template>
    <div :style="{'--inputFocusColor':inputFocusBottomColor}">
    
    
        <!----------------------------------------- 普通的邮箱登录（非二次登陆）----------------------------------------------->
        <div v-if="isSecondLogin == false"  class="email-login">
    
            <!-- 如果不是第一次邮箱登录，登录成功之后可以直接进入选角色，否则显示绑定账号的页面 -->
            <div class="general-email-login" v-show="isBindEmailToAccountView == false">
                <input v-model="EmailAddress" type="text" class="clear-input email-input" spellcheck="false" placeholder="邮箱"
                @click="inputSelected = '邮箱'"
                @blur="inputBlur"
                :class="{'input-focus':inputSelected=='邮箱'}"
                >
                <div class="number-code-container"  @click="inputSelected = '图形验证码'" :class="{'input-focus':inputSelected=='图形验证码'}">
                    <input 
                    v-model="numCode" 
                    type="text"
                    @blur="inputBlur" 
                    class="clear-input general-verify-code" 
                    spellcheck="false" 
                    placeholder="图形验证码">
                    <div class="icon-container" @click="updateValidateCode">
                        <img :src="numCodeURL" class="code-img" alt="">
                        <img src="/Account/images/signin/updateIcon.png" :class="{'update-code-icon':true, 'number-animation':clickUpdateIcon}" alt="">
                    </div>
                </div>
                <div class="verify-code-container" :class="{'input-focus':inputSelected=='邮箱验证码'}">
                    <input v-model="verifyCode" type="text" class="clear-input general-verify-code" spellcheck="false" placeholder="邮箱验证码"
                    @click="inputSelected = '邮箱验证码'"
                    @blur="inputBlur"
                    >
                    <div class="get-verify-code" v-show="showText" @click="getVerifyCode" :style="{'color':`${specialTextColor} !important`}">
                        获取验证码
                    </div>
                    <div v-show="!showText" :class="{'update-code':true, 'update-animation':clickUpdate}" alt="">
                        <span class="countdown">{{countdown}}</span>
                        <span> 秒后可重新发送</span>
                    </div>
                </div>
            </div>
    
            <!-- 第一次通过邮箱登录，需要先绑定账号 -->
            <div class="bind-account-email" v-show="isBindEmailToAccountView == true">
                <input v-model="account" type="text" class="clear-input email-input" spellcheck="false" placeholder="账号"
                @click="inputSelected = '账号'"
                @blur="inputBlur"
                :class="{'input-focus':inputSelected=='账号'}"
                >
                <input v-model="password" type="password" class="clear-input email-input" spellcheck="false" placeholder="密码"
                @click="inputSelected = '密码'"
                @blur="inputBlur"
                :class="{'input-focus':inputSelected=='密码','email-login-pwd':true}"
                >
            </div>
    
    
            <div class="tip" v-show="isBindEmailToAccountView == true">
                首次使用，请您将当前邮箱与账号绑定
            </div>
        </div>
    
    
    
        <!-------------------------------------------------------------- 二次登录 -------------------------------------------------------------->
        <div v-if="isSecondLogin == true" class="email-login">
            <input v-model="EmailAddress" type="text" class="clear-input email-input" spellcheck="false" placeholder="邮箱"
            @click="inputSelected = '二次登陆邮箱'"
            @blur="inputBlur"
            :class="{'input-focus':inputSelected=='二次登陆邮箱'}"
            >
            <div class="verify-code-container" :class="{'input-focus':inputSelected=='二次登陆验证码'}">
                <input v-model="verifyCode" type="text" class="clear-input general-verify-code" spellcheck="false" placeholder="验证码"
                @click="inputSelected = '二次登陆验证码'"
                @blur="inputBlur"
                >
                <div class="get-verify-code" v-show="showText" @click="getVerifyCode" :style="{'color':`${specialTextColor} !important`}">
                    获取验证码
                </div>
                <div v-show="!showText" :class="{'update-code':true, 'update-animation':clickUpdate}" alt="">
                    <span class="countdown">{{countdown}}</span>
                    <span> 秒后可重新发送</span>
                </div>
            </div>
        </div>
    
        <!-- 登录按钮 -->
        <div class="login-btn" @click="clickEmailLogin" v-show="isBindEmailToAccountView == false" :style="{'background-color':submitBtnBackgroundColor}">
            <div class="login-text">登&nbsp;录</div>
        </div>
        <!-- 绑定按钮 -->
        <div class="login-btn" @click="bindEmailLogin" v-show="isBindEmailToAccountView == true" :style="{'background-color':submitBtnBackgroundColor}">
            <div class="login-text">绑&nbsp;定</div>
        </div>
    </div>
    </template>
    
    <script>
    import {
        NEW_EMAIL_SEND, 
        UNIFIED_LOGIN, 
        GET_LOGIN_SEED,
        BIND_ACCOUNT,
        GET_ACCOUNT_ROLE, 
        VALIDATE_NUM_CODE
    } from '@/http/api.js'
      export default {
        name: "EmailLogin",
        props: ['isSecondLogin','config','previewConfig','Mode','bindEnterFlag'],
        data() {
          return {
            account:'',           // 账号
            password:'',          // 密码
            EmailAddress:'',          // 邮箱地址
            verifyCode:'',        // 验证码
            clickUpdate:false,    // 是否点击了更新验证码 
            countdown:60,         // 倒计时
            showText:true,
            inputSelected:'',       // 被选中的输入框名字，来添加不同的底部颜色
            isBindEmailToAccountView:false,   // 是否是第一次邮箱登录，第一次的话需要和一个账号绑定
            inputSelected:'',       // 被选中的输入框名字，来添加不同的底部颜色
            clickUpdateIcon:false,   // 实现点击刷新图标旋转功能
            numCode:'',            // 图形验证码
            numCodeURL:'',        // 数字验证码
            key:'',              // 用于加密的信息
            iv:'',                // 用于加密的信息
            encryptedEmail:'',     // 加密之后的邮箱地址
            encryptedCode:'',      // 加密之后的邮箱验证码
          }
        },
        watch:{
            bindEnterFlag:{
                handler:function(newVal, oldVal){
                    let that = this
                    if(newVal == 'EmailLogin'){
                        document.onkeydown = function(event){
                            if(event.key == 'Enter'){
                                that.clickEmailLogin() 
                            }
                        }
                    }
                },
                immediate: true
            }
        },
        computed:{
            inputFocusBottomColor() {   // 点击输入框时输入框底部的颜色
                if(this.Mode == 'preview'){    // 预览模式
                    return this.previewConfig.colorConfig.inputBoxSelect
                }else{                       
                    return this.config.colorConfig.inputBoxSelect
                }
            },
            specialTextColor(){     // 登录 > 的颜色
                if(this.Mode == 'preview'){    // 预览模式
                    return this.previewConfig.colorConfig.otherText
                }else{                       
                    return this.config.colorConfig.otherText
                }
            },
            submitBtnBackgroundColor(){   // 提交按钮的背景色
                if(this.Mode == 'preview'){    // 预览模式
                    return this.previewConfig.colorConfig.loginButton
                }else{                       
                    return this.config.colorConfig.loginButton
                }
            },
        },
        methods: {
            getSeed(){     // 获取加密种子
                let identity = this.getSessionVal('stamp')  // 获取一个唯一的标志（比如时间戳）
                GET_LOGIN_SEED(this.$qs.stringify({stamp: identity})).then((response)=>{
                    let data = response.data.result[0];
                    const key = data.Key
                    const iv = data.Iv
                    const encryptedEmail = this.encrypt(this.EmailAddress, key, iv).replace(/\+/g, '%2B');
                    const encryptedCode = this.encrypt(this.verifyCode, key, iv).replace(/\+/g, '%2B')
                    this.unifiedLogin(encryptedEmail, encryptedCode)   // 调用统一登录接口
                })
            },
            async getNewSeed(account, code){    // 获取加密种子
                let identity = this.getSessionVal('stamp');
                let encryptedInfo = {encryptedAccount:'',encryptedCode:''}    // 加密之后的对象
                await GET_LOGIN_SEED(this.$qs.stringify({stamp: identity})).then((response)=>{
                    let data = response.data.result[0]
                    let Key = data.Key
                    let Iv = data.Iv
                    encryptedInfo.encryptedAccount = this.encrypt(account, Key, Iv).replace(/\+/g, '%2B') 
                    encryptedInfo.encryptedCode = this.encrypt(code, Key, Iv).replace(/\+/g, '%2B')
                    this.encryptedEmail = this.encrypt(this.EmailAddress, Key, Iv).replace(/\+/g, '%2B')
                })
                return encryptedInfo
            },
    
            sendEmail(){        // 发送邮箱
                let param = {
                    Number:this.EmailAddress,
                    ImageVerificoationCode:this.numCode,
                    stamp:this.getSessionVal('stamp')
                }
                NEW_EMAIL_SEND(this.$qs.stringify(param)).then((res)=>{
                    let returnCode = res.data.ReturnCode
                    if(returnCode == '1'){
                        this.showText = false   // 显示倒计时
                        this.countdown = 59     // 每次点击打开时重置为60
                        let timer = setInterval(()=>{
                        this.countdown--
                        if(this.countdown <= 0){
                            clearInterval(timer)
                            this.showText = true
                        }
                        },1000)
                        this.$message.success('发送成功!');
                    }else if(returnCode == '-109001'){
                        this.$message.error('图形验证码无效');
                        this.updateValidateCode()   // 刷新图形验证码
                    }else{
                        this.$message.error('发送邮箱验证码失败');
                        this.updateValidateCode()   // 刷新图形验证码
                    }
                })
            },
            unifiedLogin(account, code){   // 统一登录
                let param = {
                    UnifiedLoginMode:3,   // 2是短信登录、3是邮箱登录
                    UniquelyIdentifies:account,
                    Certificate:code,
                    Other:{
                        stamp:this.getSessionVal('stamp')
                    }
                }
                UNIFIED_LOGIN(param).then((res)=>{
                    let userInfo = res.data    // 返回的数据
                    if(!this.isValidArray(userInfo.result)){  // 出错
                        let warningText = userInfo.ReturnText
                        let warningMessage = ''    // 警告信息
                        let errorNum = 0           // 错误次数
                        this.updateValidateCode()   // 刷新图形验证码
                        if(userInfo.ReturnCode == '-102015'){    // 无用户信息需要先绑定账号
                            this.isSecondLogin = false
                            this.isBindEmailToAccountView = true   // 显示绑定账号的页面
                        }else{
                            switch (warningText) {
                                case 'ErrCode:0 DB throwed Exception.':
                                    warningMessage = "网络繁忙，请稍后再试";
                                    break;
                                case 'ErrCode:0 Account is not exist.':
                                    warningMessage = "此用户名不存在";
                                    break;
                                case 'ErrCode:0 Password is not correct':
                                    errorNum++
                                    let msg = "用户名或密码不正确，您还可以尝试"+ (3-errorNum) +"次"
                                    if(errorNum >= 3)
                                    {
                                        msg = "您的账号由于密码累计输错3次已被锁定，请十分钟后再试"
                                    }
                                    warningMessage = msg;
                                    break;
                                case 'ErrCode:0 Account is forbidden':
                                    warningMessage = "此账户已被禁用，请联系管理员";
                                    break;
                                case 'ErrCode:0 Account expired':
                                    warningMessage = "此账户过期，请联系管理员";
                                    break;
                                case 'Invalid request':
                                    warningMessage = "请勿频繁操作"
                                    break;
                                case 'Too much failures':
                                    warningMessage = "您的账号由于密码累计输错3次已被锁定，请十分钟后再试";
                                    break;
                                case 'Already binded':
                                    warningMessage = "您所登录的账户已经被其他微信号绑定，请联系管理员确认账户绑定情况。";
                                    break;
                                case 'WXLogin student not allowed':
                                    warningMessage = "暂不支持使用学生账户绑定微信号。";
                                    break;
                                case 'ErrCode:0 not allowed':
                                    warningMessage = "抱歉，您没有权限！";
                                    break;
                                case 'Teachers have no classes':
                                    errmsg = "该账号没有任教班级，请先任教，再扫码绑定！";
                                    break;
                                //case -104:
                                //    warningMessage = "会话无效，请联系管理员";
                                //    break;
                                default:
                                    warningMessage = warningText;
                                    break;
                            }
                            this.verifyCode = '';
                            this.$message.error(warningMessage);
                        }
                    }else{    // 用户数据返回了
                        this.$emit('showChooseRole',userInfo.result)    // 把所有的账号列表传过去，显示选账号和选角色的页面 
                    }
                })
            },
            getVerifyCode(){           // 获取邮箱验证码
                if(this.EmailAddress ==''){
                    this.$message.error('请输入邮箱地址');
                }else if(this.numCode == ''){
                    this.$message.error('请输入图形验证码');
                }else{
                    if(!this.CheckEmail(this.EmailAddress)){
                        this.$message.error('邮箱格式不正确');
                    }else{
                        this.sendEmail()      //  发邮件
                    }
                }
            },
            // selectDiffRole(){   // 登录之后选择不同的角色
            //     let param = {
            //         session:this.getSession(),
            //         hostName:location.hostname,
            //         page:0
            //     }
            //     GET_ACCOUNT_ROLE(this.$qs.stringify(param)).then((res)=>{
            //         this.$emit('showChooseRole',res)   
            //     })
            // },
            loginAfterBindAccount(){   // 绑定账号成功之后，登录然后进入选角色的页面
                this.getNewSeed(this.account,this.password).then((encryptedInfo)=>{
                    let dataObj = {
                        UnifiedLoginMode:1,    // 1也可以
                        UniquelyIdentifies:encryptedInfo.encryptedAccount,
                        Certificate:encryptedInfo.encryptedCode,
                        Other:{
                            stamp:this.getSessionVal('stamp')
                        }
                    }
                    UNIFIED_LOGIN(dataObj).then((LoginInfo)=>{    // 加密账户名和密码调接口换取用户信息
                        let userInfo = LoginInfo.data    // 返回的数据
                        if(!this.isValidArray(userInfo.result)){  // 出错
                            let warningText = userInfo.ReturnText
                            let warningMessage = ''    // 警告信息
                            let errorNum = 0           // 错误次数
                            switch (warningText) {
                                case 'ErrCode:0 DB throwed Exception.':
                                    warningMessage = "网络繁忙，请稍后再试";
                                    break;
                                case 'ErrCode:0 Account is not exist.':
                                    warningMessage = "此用户名不存在";
                                    break;
                                case 'ErrCode:0 Password is not correct':
                                    errorNum++
                                    let msg = "用户名或密码不正确，您还可以尝试"+ (3-errorNum) +"次"
                                    if(errorNum >= 3)
                                    {
                                        msg = "您的账号由于密码累计输错3次已被锁定，请十分钟后再试"
                                    }
                                    warningMessage = msg;
                                    break;
                                case 'ErrCode:0 Account is forbidden':
                                    warningMessage = "此账户已被禁用，请联系管理员";
                                    break;
                                case 'ErrCode:0 Account expired':
                                    warningMessage = "此账户过期，请联系管理员";
                                    break;
                                case 'Invalid request':
                                    warningMessage = "请勿频繁操作"
                                    break;
                                case 'Too much failures':
                                    warningMessage = "您的账号由于密码累计输错3次已被锁定，请十分钟后再试";
                                    break;
                                case 'Already binded':
                                    warningMessage = "您所登录的账户已经被其他微信号绑定，请联系管理员确认账户绑定情况。";
                                    break;
                                case 'WXLogin student not allowed':
                                    warningMessage = "暂不支持使用学生账户绑定微信号。";
                                    break;
                                case 'ErrCode:0 not allowed':
                                    warningMessage = "抱歉，您没有权限！";
                                    break;
                                case 'Teachers have no classes':
                                    errmsg = "该账号没有任教班级，请先任教，再扫码绑定！";
                                    break;
                                //case -104:
                                //    warningMessage = "会话无效，请联系管理员";
                                //    break;
                                default:
                                    warningMessage = warningText;
                                    break;
                            }
                            this.$message.error(warningMessage);
                        }else{    // 用户数据返回了
    
                            this.$emit('showChooseRole',userInfo.result)    // 把所有的账号列表传过去，显示选账号和选角色的页面 
    
                            // console.log("登录成功的用户信息",userInfo.result[0])
                            // let account = userInfo.result[0]
                            // let session = account.Session
                            // let info = {
                            //     "userid": account.UserID,
                            //     "session": account.Session,
                            //     "loginname": account.LoginName,
                            //     "realname": account.RealName,
                            //     "account": account.LoginName, //showname是数据库返回的账户名（优先真实姓名，账户名次之）
                            //     "role": account.role,
                            //     "coin": account.Coin,
                            //     "level": account.level,
                            //     "avatar": account.Avatar
                            // };
                            // this.saveAccount(info)    // util.js里的方法，保存信息到本地
                            // this.selectDiffRole()    // 跳转到选择多种角色的页面
                            // this.$message({
                            //     message: '登录成功',
                            //     type: 'success'
                            // });
        
        
                            /* -------------------------- 下面是老的接口start ----------------------*/
                            // let param = {
                            //     session:session,
                            //     page:0,
                            //     hostName:location.hostname    
                            // }
                            // GET_USER_INFO(this.$qs.stringify(param)).then((res)=>{
                            //     console.log("登录的用户信息",res)
                            //     let result = res.data.result
                            //     // 警告：这里需要把cookie信息保存下来，对应的domain要设为原来那个跳转过来的平台
                            //     // this.loadSession(result,this)         // 保存信息，到cookie
                            //     this.selectDiffRole()    // 跳转到选择多种角色的页面
        
                            //     // 如果是联想项目成功后则跳转下面地址 https://educenter-lenovo.forclass.net/Cm/Dbrw
                            //     // if(location.hostname == 'educenter-lenovo.forclass.net'){
                            //     //     location.href = '/Cm/Dbrw'
                            //     // }
        
                            //     // 第三方平台另外处理
                            //     // if(this.isValidArray(result)){   // 有返回值了
                            //     //     this.Cookies.set('account',result[0])
                            //     // }
                            // })
                            /* -------------------------- 老的接口end ----------------------*/
                            
                            // 警告：登录成功之后重定向跳转回原来的页面
                            //console.log("当前session信息",session)
                        }
                    })    
                    
                })
            },
            inputBlur() {  // 输入框失去焦点取消下划线高亮
                this.inputSelected = ''
            },
            CheckEmail(email) {    // 校验邮箱格式
                var myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
                return myreg.test(email)
            },
            async updateValidateCode() {  // 更新验证码 
                this.numCode = '';    //刷新验证码时把原来的验证码置空
                let stamp = this.getSessionVal('stamp');
                if(this.numCodeURL != '') {
                    if(this.clickUpdateIcon == false) {     // 关闭旋转动画
                        this.clickUpdateIcon = true;
                        setTimeout(async () => {
                            this.numCodeURL = await this.onGetCaptcha(stamp);
                            this.clickUpdateIcon = false;
                        }, 700)
                    }
                } else {
                    this.numCodeURL = await this.onGetCaptcha(stamp);
                }
            },
            clickEmailLogin(){  // 点击邮箱登录
                let param = {
                    Number:this.EmailAddress,
                    VerificoationCode:this.verifyCode 
                }
                var reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                if(this.EmailAddress == ''){
                    this.$message.error('请输入邮箱');
                    return
                }else if(!reg.test(this.EmailAddress)){
                    this.$message.error('请输入正确格式的邮箱');
                    return
                }else if(this.numCode == ''){
                    this.$message.error('请输入图形验证码');
                    return
                }else if(this.verifyCode == ''){
                    this.$message.error('请输入邮箱验证码');
                    return
                }
                this.getSeed()   // 调用登录的接口获取信息，保存登录状态，处理登录成功之后的操作
            },
            bindAccount(){   // 如果是邮箱首次登录所以需要先绑定账户
                this.getNewSeed(this.account,this.password).then((encryptedInfo)=>{
                    let param = {
                        BindAccountMode:2,     // 1是绑定手机号 2是绑定邮箱账号
                        LoginName:encryptedInfo.encryptedAccount, // 加密之后的账号
                        Password:encryptedInfo.encryptedCode,  // 加密后的密码
                        number:this.encryptedEmail, // 邮箱或者手机号
                        Other:{
                            stamp:this.getSessionVal('stamp')     // 加密种子GetSeed的时间戳
                        }
                    }
                    // let param = {
                    //     BindAccountMode:1,     // 1是绑定手机号 2是绑定邮箱账号
                    //     LoginName:this.encrypt(this.account, this.key, this.iv).replace(/\+/g, '%2B'), // 加密之后的账号
                    //     Password:this.encrypt(this.password, this.key, this.iv).replace(/\+/g, '%2B'),  // 加密后的密码
                    //     number:this.EmailAddress, // 邮箱或者手机号
                    //     Other:{
                    //         stamp:this.getSessionVal('newEmailStamp')     // 加密种子GetSeed的时间戳
                    //     }
                    // }
    
                    BIND_ACCOUNT(param).then((res)=>{
                        let data = res.data
                        if(data.ReturnCode == '1'){
                            this.$message({
                                message: '绑定成功',
                                type: 'success'
                            });
                            this.loginAfterBindAccount()   // 应该是绑定成功之后登录
                        }else{
                            this.$message.error(data.ReturnText);
                        }
                    })
                })
            },
            bindEmailLogin(){  // 首次邮箱登录需要绑定账号
                if(this.account == ''){
                    this.$message.error('请输入账号');
                    return
                }else if(this.password == ''){
                    this.$message.error('请输入密码');
                    return
                }else{
                    this.bindAccount()   // 调接口绑定账号
                }
            },
        },
        created(){
        },
        mounted(){
            this.updateValidateCode()    // 页面加载的时候初始化数字验证码
        }
      }
    </script>
    
    <style lang="scss" scoped>
    @import "@/styles/mixin.scss";
    @include resetCheckbox();  // 清除原生input样式
    .input-focus{
        border-bottom-color: var(--inputFocusColor) !important;
    }
    .email-login {
        display: flex;
        flex-direction: column;
        .bind-account-email{
            display: flex;
            flex-direction: column;
            .email-login-pwd {
                margin-bottom: 0 !important;
            }
        }
        .general-email-login{
            display: flex;
            flex-direction: column;
        }
        .email-input{   // 短信登录的输入框
            box-sizing: border-box;
            height: 38px;
            border-bottom: 2px solid #F2F3F5;
            margin-bottom: 32px;
        }
        .email-input:nth-child(1){
            margin-top: 24px;
        }
        .verify-code-container {
            border-bottom: 2px solid #F2F3F5;
            margin-bottom: 0; 
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 32px;
            .general-verify-code{  // 验证码
                box-sizing: border-box;
                height: 38px;
                border: 0px;
                // background-color: antiquewhite;
                flex: 1;
                // border-bottom: 2px solid #F2F3F5;
                // margin-bottom: 24px;     
            }
            .get-verify-code {   // 获取验证码的文字
                width: 70px;
                height: 22px;
                color: #FF6A00;
                font-size: 14px;
                cursor: pointer;
                font-weight: 500;
                margin-top: 2px;
                margin-right: 8px;
            }
            .code-img{  // 验证码图标
                width: 48px;
                height: 17px;
                margin-right: 8px;
                margin-top: 2px;
                margin-left: auto;
            }
            .update-code{
                margin-top: 2px;
                width: 118px;
                height: 22px;
                font-size: 14px;
                color: #A9AEB8;
                margin-right: 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .countdown{
                    width: 17px;
                    text-align: right;
                }
            }
            .update-animation{   // 点击刷新二维码的图标时旋转
                animation: loading 1.2s ease-in-out infinite forwards;
            }
            @keyframes loading {  // 旋转动画
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(-360deg);
                }
            }
        }
        .number-code-container {
            border-bottom: 2px solid #F2F3F5;
            margin-bottom: 24px; 
            display: flex;
            align-items: center;
            justify-content: space-between;
            .code-img{
                width: 100px;
                height: 40px;
            }
            .general-verify-code{  // 验证码
                box-sizing: border-box;
                height: 38px;
                border: 0px;
                flex: 1;
            }
            .icon-container{
                box-sizing: border-box;
                height: 40px;
                display: flex;
                align-items: center;
                cursor: pointer;
                .update-code-icon{
                    width: 18px;
                    height: 18px;
                    margin-right: 16px;
                    margin-top: 5px;
                }
                .number-animation{   // 点击刷新二维码的图标时旋转
                    animation: loading 0.7s ease-in-out infinite forwards;
                }
                @keyframes loading {  // 旋转动画
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(-360deg);
                    }
                }
            }
        }
        .tip {  // 提示语
            font-size: 13px;
            color: #FF3B30;
            font-weight: 400;
            margin-top: 16px;
        }
    }
    .login-btn{  // 登录
        margin-top: 32px;
        width: 392px;
        height: 40px;
        background-color: #ff6a00;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        cursor: pointer;
        .login-text {
            // width: 38px;
            height: 22px;
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 500;
        }
    }
    </style>
    